<template>
    <div class="table-responsive">
        <table class="table table-bordered table-sm table-hover mb-0">
            <thead class="thead-light">
                <tr class="text-center">
                    <th>{{ "시간" }}</th>
                    <th>{{ `측정값 (${unit})` }}</th>
                    <th>{{ `보정값 (${unit})` }}</th>
                    <th>{{ "정상 범위" }}</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="tableData.length > 0">
                    <tr
                        class="text-center"
                        v-for="event in tableData"
                        :key="event.eventIdx"
                        :class="!isEmpty(eventRegDt) && eventRegDt == event.time ? 'table-danger' : ''"
                    >
                        <td>
                            {{ event.time ?? "-" }}
                        </td>
                        <td>{{ event.measuredVal !== null ? event.measuredVal : "-" }}</td>
                        <td>{{ event.ptVal !== null ? event.ptVal : "-" }}</td>
                        <td>
                            {{
                                `${event.lowerLimit !== null ? event.lowerLimit.toFixed(3) : "-"} 
                                ~ ${event.upperLimit !== null ? event.upperLimit.toFixed(3) : "-"}`
                            }}
                            <span style="cursor: pointer;" @click="showDetectParamModal(event)">
                                <i class="fa fa-question-circle"></i>
                            </span>
                        </td>
                    </tr>
                </template>
                <tr v-else class="text-center">
                    <td colspan="4" class="empty-state-cell">
                        <div class="empty-state-content">
                            <div class="empty-state-icon">
                                <i class="fa fa-check-circle"></i>
                            </div>
                            <div class="empty-state-text">
                                <h6 class="empty-state-title">{{ $t("데이터 이상이 발생하지 않았습니다.") }}</h6>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment";
import excelHelper from "@src/libs/excelHelper.js";

export default {
    props: {
        abnormalData: { type: Object, default: () => {} },
        unit: { type: String, default: "" },
        eventDetail: { type: Object, default: () => {} },
        flagAbnormalDownload: { type: Boolean, default: false },
        totalLog: { type: Array, default: () => [] },
    },
    watch: {
        flagAbnormalDownload(flag) {
            if (flag) {
                this.exportTableDataToExcel();
            }
        },
    },
    components: {},
    data() {
        return {};
    },
    computed: {
        tableData() {
            return this.abnormalData.abnormalEvents.map((event) => {
                const matchedLog = this.totalLog.find((log) => log.regDt === event.regDt);
                return {
                    ...event,
                    time: moment(event.regDt.toString(), "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss"),
                    ptVal: matchedLog ? matchedLog.ptVal : null,
                };
            });
        },
        eventRegDt() {
            let regDt;
            if (!this.isEmpty(this.eventDetail) && !this.isEmpty(this.eventDetail.regDt)) {
                regDt = moment(this.eventDetail.regDt.toString(), "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
            } else regDt = null;
            return regDt;
        },
    },
    methods: {
        async showDetectParamModal(event) {
            console.log(event);
            this.$emit("showModal", event.regDt);
        },
        async exportTableDataToExcel() {
            try {
                // 헤더 정의
                const headers = ["시간", `측정값 (${this.unit})`, `보정값 (${this.unit})`, "정상 범위"];

                // 데이터 변환 (excelHelper 형식에 맞게)
                const excelData = this.tableData.map((item) => ({
                    시간: moment(item.regDt.toString(), "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss"),
                    [`측정값 (${this.unit})`]: item.measuredVal !== null ? item.measuredVal : "-",
                    [`보정값 (${this.unit})`]: item.ptVal !== null ? item.ptVal : "-",
                    "정상 범위":
                        item.upperLimit !== null && item.lowerLimit !== null
                            ? `${item.lowerLimit.toFixed(3)} ~ ${item.upperLimit.toFixed(3)}`
                            : "-",
                }));

                // 파일명 생성 (현재 날짜 포함)
                const currentDate = new Date().toISOString().slice(0, 10);
                const fileName = `이상데이터_${currentDate}.xlsx`;

                // excelHelper를 사용하여 워크북 생성 및 다운로드
                await excelHelper.createAndDownloadWorkbook(excelData, headers, fileName, {
                    sheetName: "이상데이터",
                    creator: "THEKIE",
                    lastModifiedBy: "THEKIE",
                    columnWidths: {
                        시간: 12,
                        [`측정값 (${this.unit})`]: 15,
                        [`보정값 (${this.unit})`]: 15,
                        "정상 범위": 20,
                    },
                    cellTypes: {
                        시간: "string",
                        [`측정값 (${this.unit})`]: "number",
                        [`보정값 (${this.unit})`]: "number",
                        "정상 범위": "string",
                    },
                });

                this.$emit("update:flagAbnormalDownload", false);
            } catch (error) {
                console.error("엑셀 다운로드 중 오류 발생:", error);
                this.$emit("download-error", error.message);
            }
        },
    },
};
</script>

<style scoped>
.table-responsive {
    height: 70vh;
    overflow-y: auto;
    position: relative;
}
table {
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
}

thead {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
}
.table thead th {
    font-size: 13px;
    font-weight: 600;
}
.table tbody td {
    font-size: 13px;
}

/* Empty State Styling */
.empty-state-cell {
    padding: 60px 20px !important;
    /* background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); */
    /* border: 2px dashed #28a745; */
}
/* 
.empty-state-cell:hover {
    background: linear-gradient(135deg, #c3e6cb 0%, #b1dfbb 100%);
    border-color: #20c997;
} */

.empty-state-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

.empty-state-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
    transition: all 0.3s ease;
}

.empty-state-icon:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.empty-state-icon i {
    font-size: 20px;
    color: white;
}

.empty-state-text {
    text-align: center;
    max-width: 300px;
}

.empty-state-title {
    color: #155724;
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 16px;
}
</style>
